import { merge } from 'lodash'
import configs from '../../config'
import { Axios } from './axios'
// import { AxiosError, AxiosRequestConfig } from 'axios'
// import { ContentTypeEnum, RequestCodeEnum, RequestMethodsEnum } from '@/enums/requestEnums'
// import type { AxiosHooks } from './type'
import { clearAuthInfo, getToken } from '../auth'
// import feedback from '../feedback'
// import NProgress from 'nprogress'
//  import router from '@/router'
//  import { PageEnum } from '@/enums/pageEnum'
import { Message } from 'element-ui'
import router from '@/router'
const axiosHooks = {
    requestInterceptorsHook (config) {
        //  NProgress.start()
        const { withToken, isParamsToData } = config.requestOptions
        const params = config.params || {}
        //  console.log('==params===',params)
        // let tk = null
        // if (params.tk) {
        //     tk = params.tk
        //     //  delete params.tk
        // }
        const headers = config.headers || {}
        if (process.env.SSR_SERVER === 'TRUE' && params.atServ) {
            // config.url = configs.fullBaseUrl + config.url
            //  console.log('==params=env.SSR_SERVER=',process.env)
            //  console.log('==params=env.SSR_SERVER=',config)
        }
        // 添加token
        if (withToken) {
            const token = getToken()
            headers.token = token
        }
        // POST请求下如果无data，则将params视为data
        if (
            isParamsToData &&
            !Reflect.has(config, 'data') && (config.method && config.method.toUpperCase() === 'POST')
        ) {
            config.data = params
            config.params = {}
        }
        //  return config
        // let getConf = useAppStore().config.dataSet
        //  console.log('==params=cache=',tk)
        /* if (tk) {
            // let getConfStr = tk //  cache.get('BASE_DATA') cache是localStorage的，ssr用不了
            // let appId = configs.appId
            // if (getConfStr) {
            //     getConf = JSON.parse(decodeCookie(CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(getConfStr))))
            //     appId = getConf.app_id || ''
            // }
            let customCryptoByKey
            if (config.data) {
                // let customCrypto = new CustomCrypto();
                // config.data['appId'] = appId
                // config.data['nonceStr'] = customCrypto.randomString()
                // config.data['timestamp'] = customCrypto.timestamp()
            } else {
                config.data = {
                    // appId: appId
                }
            }
            if (getConf && getConf.encrypt && customCryptoByKey) {
                config.data = customCryptoByKey.encrypt(JSON.stringify(config.data))
                // headers.appId = appId
            }
        } */
        config.headers = headers
        return config
    },
    requestInterceptorsCatchHook (err) {
        //  NProgress.done()
        return err
    },
    async responseInterceptorsHook (response) {
        //  NProgress.done()
        const { isTransformResponse, isReturnDefaultResponse } = response.config.requestOptions

        //  返回默认响应，当需要获取响应头及其他数据时可使用
        if (isReturnDefaultResponse) {
            return response
        }
        // 是否需要对数据进行处理
        if (!isTransformResponse) {
            return response.data
        }
        const { code, data, show, msg } = response.data
        const RequestCodeEnum = {
            SUCCESS: 1,
            FAIL: 0,
            LOGIN_FAILURE: -1,
            OPEN_NEW_PAGE: 2
        }
        switch (code) {
            case RequestCodeEnum.SUCCESS:
                console.log('===RequestCodeEnum.SUCCESS===')
                // 动态导入 appStore
                /* import('../../stores/modules/app').then(module => {
                    const useAppStore = module.default
                    const appStore = useAppStore()
                    window.location.href = '/#/?dp='+ appStore.getDpId()
                })  */
               
                if (show) {
                    // success/warning/info/error
                    msg && Message({ message: msg, type: 'success' })
                }
                return data
            case RequestCodeEnum.FAIL:
                console.log('===RequestCodeEnum.FAIL===')
                if (show) {
                    //  msg && feedback.msgError(msg)
                    msg && Message({ message: msg, type: 'error' })
                }
                if (msg === '请求参数缺token') {
                    Message({ message: '登录超时，请重新登录', type: 'error' })
                    // router.push('/login')
                    // 动态导入 appStore
                    import('../../stores/modules/app').then(module => {
                        const useAppStore = module.default
                        const appStore = useAppStore()
                        window.location.href = '/#/?dp='+ appStore.getDpId()
                    }) 
                }
                return Promise.reject(data)
            case RequestCodeEnum.LOGIN_FAILURE:
                console.log('===RequestCodeEnum.LOGIN_FAILURE===')
                clearAuthInfo()
                // router.push('/login')
                //window.location.href = '/#/?dp='+ appStore.getDpId()
                // 动态导入 appStore
                import('../../stores/modules/app').then(module => {
                    const useAppStore = module.default
                    const appStore = useAppStore()
                    window.location.href = '/#/?dp='+ appStore.getDpId()
                }) 
                router.push('/login')
                console.log('登录超时')
                return Promise.reject(msg)
            case RequestCodeEnum.OPEN_NEW_PAGE:
                console.log('===equestCodeEnum.OPEN_NEW_PAGE===')
                window.location.href = data.url
                return data
            default:
                console.log('===default===')
                // 动态导入 appStore
                import('../../stores/modules/app').then(module => {
                    const useAppStore = module.default
                    const appStore = useAppStore()
                    window.location.href = '/#/?dp='+ appStore.getDpId()
                })
                return data
        }
    },
    responseInterceptorsCatchHook (error) {
        console.log(error)
        //  NProgress.done()
        // if (error.code !== AxiosError.ERR_CANCELED) {
        //     //error.message && feedback.msgError(error.message)
        // }
        // return Promise.reject(error)
    }
}

const defaultOptions = {
    //  接口超时时间
    timeout: configs.timeout,
    // 基础接口地址
    baseURL: configs.baseUrl,
    //  请求头
    headers: { 'Content-Type': 'application/json;charset=UTF-8', version: configs.version },
    // 处理 axios的钩子函数
    axiosHooks: axiosHooks,
    // 每个接口可以单独配置
    requestOptions: {
        // 是否将params视为data参数，仅限post请求
        isParamsToData: true,
        //  是否返回默认的响应
        isReturnDefaultResponse: false,
        // 需要对返回数据进行处理
        isTransformResponse: true,
        // 接口拼接地址
        urlPrefix: configs.urlPrefix,
        // 忽略重复请求
        ignoreCancelToken: false,
        // 是否携带token
        withToken: true,
        // 开启请求超时重新发起请求请求机制
        isOpenRetry: true,
        // 重新请求次数
        retryCount: 2
    }
}

function createAxios (opt) {
    //  console.log('===9===',defaultOptions)
    return new Axios(
        // 深度合并

        merge(defaultOptions, opt || {})
    )
}
const request = createAxios()
export default request



// WEBPACK FOOTER //
// ./src/utils/request/index.js